import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { externalSource, externalSourceSendCancidateResponse } from './external-source.interface';

export class ExternalSourceService {
   async getExternalSources(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<externalSource>>>('/external-sources', { ...cacheFirstConfig, params: query });
      return response.data;
   }

   async sendCandidate(sourceId: number, hitIds: Array<number>) {
      const response = await http.post<externalSourceSendCancidateResponse>(`/external-sources/${sourceId}/sendCandidate`, {
         hit_ids: hitIds,
      });
      return response.data;
   }

   async getExternalSource() {
      throw Error('Method not implemented');
   }

   async postExternalSource() {
      throw Error('Method not implemented');
   }

   async putExternalSource() {
      throw Error('Method not implemented');
   }

   async deleteExternalSource() {
      throw Error('Method not implemented');
   }
}
